var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14px",
    height: "14px",
    viewBox: "0 0 13.859 15.245",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M14.473,2.386H13.78V1.693a.693.693,0,0,0-1.386,0v.693H5.465V1.693a.693.693,0,1,0-1.386,0v.693H3.386A1.39,1.39,0,0,0,2,3.772V14.859a1.39,1.39,0,0,0,1.386,1.386H14.473a1.39,1.39,0,0,0,1.386-1.386V3.772A1.39,1.39,0,0,0,14.473,2.386ZM13.78,14.859h-9.7a.7.7,0,0,1-.693-.693V5.851H14.473v8.316A.7.7,0,0,1,13.78,14.859Z",
    transform: "translate(-2 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.8390e9b14d71d629a7477c6cc8cf35c1.svg";
export { ForwardRef as ReactComponent };